<template>
  <div v-if="ordreTravail">
    <div class="entete border-entete">
      <div class="is-paddingless section section-details">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('detailOrdreTravailAffichage.title', { code: ordreTravail.code }) }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <a ref="lienDownload"></a>
          <div class="level-right">
            <div class="buttons">
              <button class="button"
                :class="{'pointer-events-none button-access-no-permission'
                  : checkReturnButton }"
                 @click="$router.go(-1)">
                {{ $t('detailOrdreTravailAffichage.actions.cancel') }}
              </button>
              <button class="button is-addOrEdit"
                v-if="ordreTravail.etat === constantes.ETAT_ENREGISTRE"
                :class="{ 'button-access-no-permission' :
                  !checkPermissions(permOrdreTravail.maj) }"
                @click="checkPermissions(permOrdreTravail.maj) ? $router.push({
                  name: 'm.logistique.ordre_travail-affichage',
                  params: { id: ordreTravail.id}}) : showPopUp()">
                {{ $t('detailOrdreTravailAffichage.actions.editer') }}
              </button>

              <dropdownButton
                type="is-addOrEdit"
                class="mgr-2"
                :permission="permOrdreTravail.maj"
                v-if="ordreTravail.etat === constantes.ETAT_ENREGISTRE"
                :actions="actionSecondary"
                @click="popUpPrevention = true;">
                  {{ $t('detailOrdreTravailAffichage.actions.cloture') }}
              </dropdownButton>

              <button class="button is-addOrEdit"
                v-if="ordreTravail.etat === constantes.ETAT_CLOTURER"
                @click="checkPermissions(permOrdreTravail.maj) ?
                   popUpPreventionReactivation = true : showPopUp()"
                :class="{'button-access-no-permission':
                  !checkPermissions(permOrdreTravail.maj)}">
                {{ $t('detailOrdreTravailAffichage.actions.reactiver') }}
              </button>
              <button class="button"
                :class="{'button-access-no-permission':
                  !checkPermissions(permOrdreTravail.lecture)}"
                @click="checkPermissions(permOrdreTravail.lecture) ?
                  openPopUpEmail() : showPopUp()">
                <b-icon icon="email-plus" type="is-default"></b-icon>
              </button>
              <button class="button"
                @click="$refs.dropdownEdition.toggle()">
                <div>
                  <b-icon icon="file-download" class="mgr-10px" type="is-default"></b-icon>
                  <b-dropdown ref="dropdownEdition" position="is-bottom-left">
                    <div slot="trigger">
                      <b-icon icon="chevron-down"
                        class="has-text-secondary-icon">
                      </b-icon>
                    </div>
                    <b-dropdown-item class="has-text-left"
                      @click="checkPermissions(permOrdreTravail.editer) ? edition({
                        format: constantes.TYPE_PDF,
                        typeDonnee: constantes.TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE })
                        : showPopUp()">
                      {{ $t('general.popUpEdition.type.pdf') }}
                    </b-dropdown-item>
                    <b-dropdown-item class="has-text-left"
                      @click="checkPermissions(permOrdreTravail.editer) ? edition({
                        format: constantes.TYPE_DOCX,
                        typeDonnee: constantes.TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE })
                        : showPopUp()">
                      {{ $t('general.popUpEdition.type.docx') }}
                    </b-dropdown-item>
                    <b-dropdown-item class="has-text-left"
                      @click="checkPermissions(permOrdreTravail.editer)
                        ? openPopupEdition() : showPopUp()">
                      {{ $t('general.popUpEdition.type.other') }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </button>
              <button class="button"
                @click="$refs.dropdownAffectation.toggle()">
                <div>
                  <b-icon icon="call-split" class="mgr-10px" type="is-default"></b-icon>
                  <b-dropdown ref="dropdownAffectation" position="is-bottom-left">
                    <div slot="trigger">
                      <b-icon icon="chevron-down"
                        class="has-text-secondary-icon">
                      </b-icon>
                    </div>
                    <b-dropdown-item has-link class="has-text-left">
                      <router-link-blank :to="{ name: 'm.logistique.ordre_travail-affectation',
                          params: { id: ordreTravail.id }}"
                        class="pdt-5px pdb-5px"
                        classMessage="has-text-default is-size-6 is-block"
                        classComposant="noTextDecoration"
                        :message="$t('detailOrdreTravailAffichage.actions.accesAffectation')">
                      </router-link-blank>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </button>
              <piece-jointe-button
                class="mgr-2"
                :perm="permOrdreTravail.maj"
                autoSave>
              </piece-jointe-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <ordre-travail-consultation
        @getFacesLogo="loadOt($event)"
        :ordreTravail="ordreTravail"
        :consultation="true">
      </ordre-travail-consultation>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('piecesJointes.attachments')}}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes readOnly
          deletable
          autoSave
          :checkPermissions="checkPermissions(permOrdreTravail.maj)"
        />
      </div>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up
        :messHeader="this.$t('detailOrdreTravailAffichage.popUpSuppression.title')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteOt"/>
    </b-modal>
    <b-modal v-model="popUpMail" has-modal-card class="modal">
      <pop-up-mail
        :mail="mail"
        :title="'detailFacture.popUpMail.title'"
        :error="errorEmail"
        :editionsAInclure="editionsAInclure"
        @sendEmail="envoieMail()">
      </pop-up-mail>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :choiceEdition="getListeChoiceEdition"
        :error="errorEdition"
        @editionChoose="edition"
      >
      </pop-up-edition>
    </b-modal>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <pop-up
        :messHeader="this.$t('detailOrdreTravailAffichage.popUpClocture.title')"
        :messagesPopup="messagesPopUp"
        :isErrorPopup.sync="isErrorPopUp"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="closePopUpCloture"
        @yes="clotureOrdreTravail"/>
    </b-modal>
    <b-modal v-model="popUpPreventionReactivation" has-modal-card class="modal">
      <pop-up
        :messHeader="this.$t('detailOrdreTravailAffichage.popUpReactive.title')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        :messagesPopup="messagesPopUp"
        :isErrorPopup.sync="isErrorPopUp"
        @no="closePopUpReactiver"
        @yes="reactivationOrdreTravail"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import {
  get, deleteAllOt, cloture, reactiver,
} from '@/api/logistique/ordreTravailAffichage';
import breadcrumb from '@/components/general/breadcrumb';
import dropdownButton from '@/components/general/button/dropdownButton';
import inProgress from '@/services/general/inProgress';
import { ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import ordreTravailConsultation from '@/components/logistique/ordreTravail/affichage/ordreTravailAffichageConsultation';
import popUp from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import {
  ETAT_ENREGISTRE, TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE,
  LISTE_CHOICE_EDITION_OT, OT_AVEC_RESEAU,
  ETAT_CLOTURER,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import edition from '@/api/edition';
import envoieMailOtAffichage from '@/services/logistique/ordreTravail/affichage/envoieMailOtAffichage';
import validationEnvoieMail from '@/services/general/validation/validationEnvoieMail';
import popUpMail from '@/components/general/p_mail';
import { TYPE_PDF, TYPE_DOCX } from '@/configuration/edition/editionConf';
import popUpEdition from '@/components/logistique/ordreTravail/affichage/p_edition';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import validation from '@/services/logistique/chargeTravail/affichage/validation';
import generationMailPourOtAffichage from '@/services/logistique/ordreTravail/affichage/generationMailPourOtAffichage';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import PiecesJointes from '@/components/general/piecesJointes';
import getPiecesJointeLogoByIds from '@/services/piecesJointes/getPiecesJointeLogoByIds';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import validationEdition from '@/services/general/validation/validationRetourEdition';

const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');
const Attachments = createNamespacedHelpers('attachments');

export default {
  name: 'c_ordreTravail',
  data() {
    return {
      permOrdreTravail: ORDRE_TRAVAIL,
      ordreTravail: null,
      popUpMail: false,
      popUpSuppression: false,
      popUpPrevention: false,
      popUpPreventionReactivation: false,
      messagesPopUp: [],
      isErrorPopUp: false,
      mail: null,
      editionsAInclure: [{ libelle: 'detailOrdreTravailTech.popUpMail.inclureOt', key: 'mettreEdition', value: true }],
      messagesPopup: [''],
      isErrorPopup: false,
      popUpEdition: false,
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      constantes: {
        TYPE_EDITION_ORDRE_TRAVAIL_AFFICHAGE,
        TYPE_PDF,
        TYPE_DOCX,
        ETAT_CLOTURER,
        ETAT_ENREGISTRE,
      },
      errorEmail: {
        haveError: false,
        messages: [],
      },
    };
  },
  components: {
    breadcrumb,
    dropdownButton,
    ordreTravailConsultation,
    popUp,
    popUpEdition,
    routerLinkBlank,
    popUpMail,
    pieceJointeButton,
    appPiecesJointes: PiecesJointes,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    inProgress() {
      inProgress(this.$i18n);
    },
    async deleteOt() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAllOt([this.$route.params.id]);
        messageSucces(this.$t('detailOrdreTravailAffichage.messages.success.otDelete'));
        loadingComponent.close();
        await this.$router.push({ name: 'l.logistique.ordre_travail-affichage' });
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    openPopupEdition() {
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      this.popUpEdition = true;
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      try {
        const response = await edition({
          ids: [this.ordreTravail.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
        loadingComponent.close();
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationEdition(response, this.errorEdition.messages);
          this.errorEdition.haveError = true;
          this.isError = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async clotureOrdreTravail() {
      const loadingComponent = this.$buefy.loading.open();
      this.messagesPopUp = [];
      try {
        await cloture(this.ordreTravail.id);
        this.popUpPrevention = false;
        messageSucces(this.$i18n.t('detailOrdreTravailAffichage.popUpClocture.success'));
        await this.$router.go(0);
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.isErrorPopUp = true;
          validation(e.response, this.messagesPopUp);
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async reactivationOrdreTravail() {
      const loadingComponent = this.$buefy.loading.open();
      this.messagesPopUp = [];
      try {
        await reactiver(this.ordreTravail.id);
        this.popUpPreventionReactivation = false;
        messageSucces(this.$i18n.t('detailOrdreTravailAffichage.popUpReactive.success'));
        await this.$router.go(0);
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.isErrorPopUp = true;
          validation(e.response, this.messagesPopUp);
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async envoieMail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEmail.messages = [];
        this.errorEmail.haveError = false;
        await envoieMailOtAffichage(this.mail, this.editionsAInclure[0].value,
          this.ordreTravail.societeId, this.ordreTravail.id);
        messageSucces(this.$i18n.t('mail.success.envoie'));
        this.popUpMail = false;
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationEnvoieMail(e.response, this.errorEmail.messages);
          this.errorEmail.haveError = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async openPopUpEmail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEmail.messages = [];
        this.errorEmail.haveError = false;
        this.mail = await generationMailPourOtAffichage(
          this.ordreTravail.afficheurId,
          this.user,
        );
        this.mail.objet = this.$i18n.t('detailOrdreTravailAffichage.popUpMail.otObject', {
          code: this.ordreTravail.code,
        });
        this.popUpMail = true;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    closePopUpCloture() {
      this.popUpPrevention = false;
      this.isErrorPopUp = false;
      this.messagesPopUp = [];
    },
    closePopUpReactiver() {
      this.popUpPreventionReactivation = false;
      this.isErrorPopUp = false;
      this.messagesPopUp = [];
    },
    async loadOt(withoutImage) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.setAttachmentContext({ module: 'OrdreTravail' });
        const ordreTravail = (await get(this.$route.params.id)).data.result;
        if (!withoutImage) await getPiecesJointeLogoByIds(ordreTravail.faces);
        await this.setAttachmentElementId({ id: ordreTravail.id });
        await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.editionOtWithReseau.key]);
        this.setInformationPage(this.$t('pageGeneral.detail', { item: ordreTravail.code }));
        this.ordreTravail = cloneDeep(ordreTravail);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
      // l'alternance de couleur des lignes du tableau se fait par materiel
      const materielsIds = [...new Set(this.ordreTravail.faces.map(f => f.materielId))];
      materielsIds.forEach(matId => {
        const pair = materielsIds.indexOf(matId) % 2 === 0;
        const pairImpair = pair ? 'ot-tab-col-pair' : 'ot-tab-col-impair';
        this.ordreTravail.faces.filter(f => f.materielId === matId)
          .forEach(f => {
            f.pairImpair = pairImpair;
          });
      });
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    getListeChoiceEdition() {
      const listesChoice = cloneDeep(LISTE_CHOICE_EDITION_OT);
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.editionOtWithReseau.key)) {
        const indexEditionOt = listesChoice.findIndex(l => l.typeEdition === OT_AVEC_RESEAU);
        listesChoice.splice(indexEditionOt, 1);
      }
      return listesChoice;
    },
    checkReturnButton() {
      return window.history.length === 1;
    },
    actionSecondary() {
      const actions = [];

      if (this.ordreTravail.etat === ETAT_ENREGISTRE) {
        actions.push(
          {
            label: this.$t('detailOrdreTravailAffichage.actions.delete'),
            action: () => { this.popUpSuppression = true; },
            permissionAction: ORDRE_TRAVAIL.supprimer,
          },
        );
      }

      return actions;
    },
    breadcrumb() {
      return [
        { title: this.$t('detailOrdreTravailAffichage.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('detailOrdreTravailAffichage.breadcrumb.ordreTravail'), route: { name: 'l.logistique.ordre_travail-affichage' }, isActive: false },
        { title: this.$t('detailOrdreTravailAffichage.breadcrumb.detailOrdreTravailAffichage'), route: '', isActive: true },
      ];
    },
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  async mounted() {
    await this.loadOt();
  },
};
</script>

<style scoped>

</style>
